const state = {
  dataList: [],
  historyApiMethod: null,
  searchApiMethod: null,
  addHistoryApiMethod: null,
  searchParams: {},
  historyParams: {},
  addHistoryParams: {},
}
const getters = {
  dataList: (state) => state.dataList,
  historyApiMethod: (state) => state.historyApiMethod,
  searchApiMethod: (state) => state.searchApiMethod,
  addHistoryApiMethod: (state) => state.addHistoryApiMethod,
  searchParams: (state) => state.searchParams,
  historyParams: (state) => state.historyParams,
  addHistoryParams: (state) => state.addHistoryParams,
}

const mutations = {
  setDataList (state, list) {
    state.dataList = list
  },
  setHistoryApiMethod (state, method) {
    state.historyApiMethod = method
  },
  setAddHistoryApiMethod (state, method) {
    state.addHistoryApiMethod = method
  },
  setSearchApiMethod (state, method) {
    state.searchApiMethod = method
  },
  setSearchParams (state, params) {
    state.searchParams = params
  },
  setHistoryParams (state, params) {
    state.historyParams = params
  },
  setAddHistoryParams (state, params) {
    state.addHistoryParams = params
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
